import { createFileRoute } from '@tanstack/react-router'
import { StaffAsetDesa } from '../../../../components/StaffAsetDesa'

export const Route = createFileRoute('/platform/desa/$desaId/administrasi')({
  component: () => {
    const { desaId } = Route.useParams()
    return <StaffAsetDesa desaId={desaId} />
  },
})
